module.exports = __webpack_public_path__ + "media/images/common/about/icon_moto-90a921737a0bad6d02f3da091a7d7c92.svg";